/* @flow */
import {
  SHOW_LOGIN,
  HIDE_LOGIN,
  SHOW360,
  HIDE360,
  GET_HOME_SLIDES_SUCCESS,
  GET_HOME_SLIDES_FAILURE,
  LOGIN_SUCCESS,
  TO_REGISTER,
  LOGOUT_SUCCESS,
  UPDATE_ACCOUNT_PROFILE_SUCCESS,
  UPDATE_ACCOUNT_FAVORITES_SUCCESS,
  SHOW_ALERT,
  HIDE_ALERT,
  CHANGE_CURRENCY,
  SHOW_LOADING,
  HIDE_LOADING,
  SHOW_MESSAGE_MODAL,
  HIDE_MESSAGE_MODAL,
  GET_MESSAGES_SUCCESS,
  UPDATE_LOCAL_ANNOUNCEMENTS,
  UPDATE_CATEGORIES_STATE,
} from '../../configs/constants'
import InitialState from './initialState'

const initialState = new InitialState()

export default function globalReducer(state = initialState, action) {
  if (!(state instanceof InitialState)) return initialState.merge(state)

  switch (action.type) {
    case SHOW_LOADING:
      return state.set('isLoading', true)
    case HIDE_LOADING:
      return state.set('isLoading', false)
    case SHOW_LOGIN:
      return state.set('isLoginModalShown', true)
    case HIDE_LOGIN:
      return state.set('isLoginModalShown', false)
                  .set('registerInfo', null)
    case LOGIN_SUCCESS:
      return state.set('user', action.user)
                  .set('isLoginModalShown', false)
    // case LOGIN_FAILURE:
    //   return {
    //     ...state,
    //     error: action.error
    //   }
    case UPDATE_ACCOUNT_PROFILE_SUCCESS:
      return state.set('user', { ...state.user, ...action.profile })
    case UPDATE_ACCOUNT_FAVORITES_SUCCESS:
      return state.set('user', { ...state.user, ...state.user.profile, favorites: action.favorites })
    case TO_REGISTER:
      return state.set('registerInfo', action.registerInfo)
    case LOGOUT_SUCCESS:
      return state.set('user', null)
    // case LOGOUT_FAILURE:
    //   return {
    //     ...state,
    //     error: action.error
    //   }
    case SHOW360:
      return state.set('isVideoModalShown', true)
                  .set('item360', action.payload)
    case HIDE360:
      return state.set('isVideoModalShown', false)
    case SHOW_ALERT:
      return state.set('alert', action.payload)
    case HIDE_ALERT:
      return state.set('alert', action.payload)
    case GET_HOME_SLIDES_SUCCESS:
      return state.set('slides', action.slides)
    case GET_HOME_SLIDES_FAILURE:
      return state.set('error', action.error)
    case UPDATE_LOCAL_ANNOUNCEMENTS:
      return state.set('announcements', action.announcements)
    case UPDATE_CATEGORIES_STATE:
      return state.set('categories', action.categories)
    case CHANGE_CURRENCY:
      return state.set('currency', action.payload)
    case SHOW_MESSAGE_MODAL:
      return state.set('isMessageModalShown', true)
                  .set('messageModalParams', action.payload)
    case HIDE_MESSAGE_MODAL:
      return state.set('isMessageModalShown', false)
    case GET_MESSAGES_SUCCESS:
      return state.set('messages', action.messages)
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/reducers/global/index.js